export default "__VITE_ASSET__IBdrTR$H__"